import useOnlineStatus from "../hooks/useOnlineStatus";

export default function OfflineBanner() {
  const isOnline = useOnlineStatus();
  if (isOnline) return null;
  return (
    <div className="alert alert-warning" role="status" aria-live="polite">
      You appear to be offline. Some information may be out of date, and RSVPs cannot be submitted until you
      reconnect.
    </div>
  );
}
